import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AppContext } from '../../../App';
import ButtonGlynt from '../../common/Buttons/ButtonGlynt';
import { useDocumentUpdate } from '../../hooks/useDocumentUpdate';
import { AxiosError } from 'axios';
import SetVendorDialog from '../../common/Dialog/SetVendorDialog';

interface ISetVendorProps {
  documentId: string;
  currentVendorId?: number | null;
}

const SetVendor: React.FC<ISetVendorProps> = ({ documentId, currentVendorId }) => {
  const { setToast } = React.useContext(AppContext);
  const [open, setOpen] = React.useState(false);

  const queryClient = useQueryClient();

  const { mutateAsync: updateDocument, isPending: isUpdating } = useDocumentUpdate({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['documents']
      });
      setToast({ variant: 'success', open: true, message: 'Vendor updated.' });
      setOpen(false);
    },
    onError: (error: AxiosError) => {
      setToast({
        variant: 'error',
        open: true,
        message: error.message || 'Failed to update vendor.',
      });
    },
  });

  const handleSubmit = async (vendorId: number | null) => {
    await updateDocument({ id: documentId, data: { vendor: vendorId } });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <ButtonGlynt
          variant="outlined"
          size="xs"
          data-cy="btn-set-vendor"
          onClick={() => setOpen(true)}
          sx={{ marginTop: '5px' }}
        >
          Edit
        </ButtonGlynt>
      </div>

      <SetVendorDialog
        open={open}
        currentVendorId={currentVendorId}
        isUpdating={isUpdating}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default SetVendor;
